import * as React from "react";

import { AbsoluteResolvedModelPath } from "../../../../../../Common/ModelPath/ModelPath";
import { reject } from "../../../../../../Common/TypingUtils";

interface PushInstanceProps {
    instance: string;
    bindingPath: AbsoluteResolvedModelPath;
    children: React.ReactNode;
}

export interface CurrentInstanceContext {
    bindingPath: AbsoluteResolvedModelPath;
    instance: string;
}

const PushInstanceContextObject = React.createContext<CurrentInstanceContext[]>([]);

export function useInstancesStack(): CurrentInstanceContext[] {
    return React.useContext(PushInstanceContextObject);
}

export function useClosestParentInstanceStrict(): CurrentInstanceContext {
    return useClosestParentInstance() ?? reject();
}

export function useClosestParentInstance(): CurrentInstanceContext | undefined {
    const parentInstances = React.useContext(PushInstanceContextObject);
    return parentInstances[parentInstances.length - 1];
}

export function PushInstance(props: PushInstanceProps): JSX.Element {
    const parentInstances = useInstancesStack();

    const nextInstances = React.useMemo(
        () => [
            ...parentInstances,
            {
                bindingPath: props.bindingPath,
                instance: props.instance,
            },
        ],
        [parentInstances, props.bindingPath.toLegacyPath(), props.instance]
    );
    return (
        <PushInstanceContextObject.Provider value={nextInstances}>{props.children}</PushInstanceContextObject.Provider>
    );
}
